/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeviceTypeEtcResponse,
    DeviceTypeEtcResponseFromJSON,
    DeviceTypeEtcResponseFromJSONTyped,
    DeviceTypeEtcResponseToJSON,
} from './DeviceTypeEtcResponse';

/**
 * 
 * @export
 * @interface DeviceTypeResponse
 */
export interface DeviceTypeResponse {
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeResponse
     */
    hardwareId: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeResponse
     */
    usageId: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeResponse
     */
    deviceName: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeResponse
     */
    allowDelete: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeResponse
     */
    rescueName: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeResponse
     */
    scope: string;
    /**
     * 
     * @type {DeviceTypeEtcResponse}
     * @memberof DeviceTypeResponse
     */
    etc?: DeviceTypeEtcResponse | null;
}

export function DeviceTypeResponseFromJSON(json: any): DeviceTypeResponse {
    return DeviceTypeResponseFromJSONTyped(json, false);
}

export function DeviceTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'hardwareId': json['hardwareId'],
        'usageId': json['usageId'],
        'deviceName': json['deviceName'],
        'allowDelete': json['allowDelete'],
        'rescueName': json['rescueName'],
        'scope': json['scope'],
        'etc': !exists(json, 'etc') ? undefined : DeviceTypeEtcResponseFromJSON(json['etc']),
    };
}

export function DeviceTypeResponseToJSON(value?: DeviceTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'hardwareId': value.hardwareId,
        'usageId': value.usageId,
        'deviceName': value.deviceName,
        'allowDelete': value.allowDelete,
        'rescueName': value.rescueName,
        'scope': value.scope,
        'etc': DeviceTypeEtcResponseToJSON(value.etc),
    };
}

